import { render, staticRenderFns } from "./GettingStartedModal.vue?vue&type=template&id=7ac41ad3&"
import script from "./GettingStartedModal.vue?vue&type=script&lang=js&"
export * from "./GettingStartedModal.vue?vue&type=script&lang=js&"
import style0 from "./GettingStartedModal.vue?vue&type=style&index=0&id=7ac41ad3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports